import * as React from 'react'
import { Route, RouteComponentProps, RouteProps, Switch } from 'react-router-dom'
import ProviderTripsManagement from '../../../containers/trips/ProviderTripsManagement'
import OrgTripsManagement from '../../../containers/trips/OrgTripsManagement'
import AssignOperatorModal from '../../../containers/trips/management/AssignOperatorModal'
import ManualTripCancelModal from '../../../containers/trips/ManualTripCancelModal'
import ErrorBoundary from '../../ErrorBoundary'
import { ITripFilters } from '../../../types'

interface ITripsManagementPaneProps {
  orgId: string
  routeProps: RouteComponentProps<any>
  updateTripFilters: (filters: ITripFilters) => Promise<any>
}

class TripsManagementPane extends React.Component<ITripsManagementPaneProps> {
  public render() {
    // Not sure which trip management table to leave
    // const TripsManagement = this.props.providerId ? ProviderTripsManagement : OrgTripsManagement
    const TripsManagement = ProviderTripsManagement
    return (
      <section className='fit-height'>
        <div className=' bg-white fit-height'>
          <ErrorBoundary>
            <Switch>
              <Route path={`${this.props.routeProps.match.path}/`} exact={true} component={TripsManagement} />
              <Route
                path={`${this.props.routeProps.match.path}/:tripId/assign-operator`}
                exact={true}
                component={AssignOperatorModal}
              />
              <Route
                path={`${this.props.routeProps.match.path}/:tripId/cancel-manually`}
                exact={true}
                component={ManualTripCancelModal}
              />
            </Switch>
          </ErrorBoundary>
        </div>
      </section>
    )
  }
}

export default TripsManagementPane



// WEBPACK FOOTER //
// ./src/components/trips/management/TripsManagementPane.tsx